import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useIntl } from 'react-intl';

import MobileActionSheet from 'components/MobileActionSheet';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import messages from './WeeklyEarnings.messages';
import WeeklyEarningsTooltip, { tooltipShape } from './WeeklyEarningsTooltip';

import './MobileTooltipSheet.scss';

const { element } = bem('weekly-earnings');

function MobileTooltipSheet({ isOpen, tooltip, campaignsPath, opportunitiesPath, classLabel, venueId, onClose }) {
  const intl = useIntl();

  const classTypesLabel = intl.formatMessage(messages.sheetSubtitleClassTypes, {
    classLabel: classLabel || intl.formatMessage(messages.classTypesFilterAllOption),
  });

  return (
    <MobileActionSheet className={element('sheet-wrapper')} isOpen={isOpen} onClose={onClose}>
      <div aria-modal="true" role="dialog" className={element('sheet-dialog')}>
        <div className={element('sheet-header')}>
          <button aria-label="Close" className={element('sheet-close')} onClick={onClose} type="button">
            <Isvg aria-hidden src={ICONS.cardsClose} />
          </button>
          <div className={element('sheet-heading')}>
            <Message as="p" className={element('sheet-title')} message={messages.sheetTitle} />
            <div className={element('sheet-subtitle')}>
              {tooltip?.periodSubtitle && <p>{tooltip.periodSubtitle}</p>}
              <p>{classTypesLabel}</p>
            </div>
          </div>
        </div>
        <div className={element('sheet-body')}>
          {tooltip && (
            <WeeklyEarningsTooltip
              campaignsPath={campaignsPath}
              hideTitle
              opportunitiesPath={opportunitiesPath}
              tooltip={tooltip}
              venueId={venueId}
            />
          )}
        </div>
      </div>
    </MobileActionSheet>
  );
}

MobileTooltipSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  tooltip: tooltipShape,
  campaignsPath: PropTypes.string,
  classLabel: PropTypes.string,
  opportunitiesPath: PropTypes.string,
  venueId: PropTypes.number,
  onClose: PropTypes.func.isRequired,
};

export default MobileTooltipSheet;
